import _ from 'lodash';

import { Common } from './common';
import { Payor as DeprecatedPayor } from './models/patient/insuranceInformation';
import * as Payor from './models/payor';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(query: Payor.FindAllOptions = {}): Promise<Payor.Payor[]> {
    const url = this.common.constructPath('/payors', {
      ...query,
      populated: true,
    });
    return this.common.getJSON(url);
  }

  async findAllPayors(
    query: Payor.FindAllOptions = {},
    includeDeprecated = true,
  ): Promise<string[]> {
    const url = this.common.constructPath('/payors', query);
    const res: Payor.Payor[] = await this.common.getJSON(url);
    const payors = res.map((payor) => payor.name);
    return includeDeprecated
      ? _.uniq([...Object.values(DeprecatedPayor), ...payors])
      : payors;
  }

  async findOneById(id: string): Promise<Payor.Payor> {
    const url = this.common.constructPath(`/payors/${id}`, { populated: true });
    return this.common.getJSON(url);
  }

  async create(values: Payor.CreateValues): Promise<Payor.Payor> {
    const url = this.common.constructPath('/payors');
    return this.common.postJSON(url, values);
  }

  async update(id: string, values: Payor.UpdateValues): Promise<Payor.Payor> {
    const url = this.common.constructPath(`/payors/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`/payors/${id}`);
    return this.common.deleteJSON(url);
  }
}
